module.exports = __webpack_public_path__ + "img/nodataJobsGraph.71b65e16.svg";